module.exports = __webpack_public_path__ + "media/src/images/icons/arrow_upward_right-fd25041f3371cdb974737b87c63f2d65.svg";